<template>
  <v-container class="pa-0 pr-0" :class="$vuetify.display.mdAndUp ? 'pl-0' : ''">
    <v-row class="mb-2 pb-1 pl-0 justify-start">
      <v-col cols="12" class="px-0">
        <h4
          :class="$vuetify.display.xs ? 'text-center' : 'text-left'"
          class="text-h4 font-weight-medium mb-3 text-left"
        >
          {{ $t('L_my_office') }}
        </h4>
        <a
          v-if="rep?.office"
          :href="navigateTo"
          target="_blank"
          :aria-label="$t('L_opens_new_window') + ' ' + linkAddr"
          class="text-decoration-none"
        >
          <v-row justify-sm="start" justify="start" align-content="center" class="pb-4 pl-0">
            <v-col cols="12" class="pl-0 pr-0">
              <div
                class="d-flex justify-start pl-0"
                :class="{ 'align-start': $vuetify.display.smAndUp }"
              >
                <div class="font-weight-medium mr-1 pr-0 pl-0">
                  <v-icon color="primary" size="32px" :icon="mdiMapMarker" />
                </div>
                <div class="addressText pl-0 text-left">
                  <p class="mb-2 text-body-2 font-weight-bold blueLinkPointer">
                    {{ rep?.office?.address1 }}
                  </p>
                  <p
                    v-if="rep?.office?.address2"
                    class="mb-2 hidden-sm-and-down text-body-2 font-weight-bold blueLinkPointer"
                  >
                    {{ rep?.office?.address2 }}
                    <br class="hidden-sm-and-down" />
                  </p>
                  <p class="mb-2 text-body-2 font-weight-bold blueLinkPointer">
                    {{ rep?.office?.city }}, {{ rep?.office?.state }} {{ rep?.office?.zip }}
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </a>
        <div class="pt-0">
          <v-row v-if="!rep?.isRvp" class="text-left pb-4">
            <v-col cols="12" class="pt-0">
              <p class="text-body-2 greyText repWorkWidth">
                {{ $t('L_rep_working_out_of') }}&nbsp;{{ rvpInfo }}
              </p>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { titleCase } from '@/shared/util/formatters';
import { mdiMapMarker } from '@mdi/js';
import { defineComponent } from 'vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapState } from 'pinia';
import { LOCALES } from '@/shared/models/constants.models';

export default defineComponent({
  name: 'MyRepAddressComponent',
  props: {
    rep: {
      type: Object,
      required: true,
      default: () => undefined,
    },
  },
  data: () => ({
    mapLinks: {
      iphone: 'maps://maps.google.com/?address=',
      android: 'http://maps.google.com/?daddr=',
      web: 'http://maps.google.com/?daddr=',
    },
    navigateTo: '',
    linkAddr: '',
    mdiMapMarker,
  }),
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    rvpInfo() {
      if (this.locale === LOCALES.en_CA || this.locale === LOCALES.fr_CA) {
        return titleCase(`${this.rep?.rvp?.name}`);
      } else if (this.rep?.rvp) {
        return titleCase(`${this.rep.rvp?.titleDescription} ${this.rep.rvp?.name}`);
      } else if (this.rep?.titleDescription && this.rep.name) {
        return titleCase(`${this.rep.titleDescription} ${this.rep.name}`);
      }
      return '';
    },
  },
  methods: {
    setAddressToNavigate(office: {
      address1?: string;
      address2?: string;
      city?: string;
      state?: string;
      zip?: string;
    }) {
      const device = this.getUserAgent();
      const address2 = office.address2 ? ` ${office.address2}` : '';
      this.linkAddr = `${office.address1}${address2} ${office.city} ${office.state} ${office.zip}`;
      this.navigateTo =
        this.mapLinks[device] +
        this.linkAddr
          .toLowerCase()
          .replace(/ /g, '+')
          .replace(/,|-|_|\./g, '');
    },
    getUserAgent() {
      const uA = navigator.userAgent;
      if (uA.includes('iPhone') || uA.includes('iPad')) {
        return 'iphone';
      }
      if (uA.includes('Android')) {
        return 'android';
      }
      return 'web';
    },
  },
  mounted() {
    this.setAddressToNavigate(this.rep?.office);
  },
});
</script>
<style scoped lang="scss">
.addressText {
  color: #02579e;
  font-size: 16px;
  font-weight: 600;
}

.greyText {
  color: #333333;
  font-size: 12px;
}

.iconSpacingLeft {
  margin-left: 28px;
}
.blueLinkPointer {
  text-decoration: none;
  color: rgb(12, 109, 202);
  font-weight: 600;
  cursor: pointer;
}
.repWorkWidth {
  max-width: 220px !important;
}
</style>
